/**
 * A global namespace for `Alt` key.
 * e.which = 18
 */
const keyAlt = 'Alt';

export default keyAlt;
